export const imageLogoEctSVG = `<svg
        xmlns:dc="http://purl.org/dc/elements/1.1/"
        xmlns:cc="http://creativecommons.org/ns#"
        xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
        xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
        xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
        xmlns="http://www.w3.org/2000/svg"
        width="187.49866mm"
        height="38.430935mm"
        viewBox="0 0 664.36532 136.1726"
        id="svg3708"
        version="1.1"
        inkscape:version="0.91 r13725"
        sodipodi:docname="logo-ect.svg">
    <defs
            id="defs3710">
        <linearGradient
                x1="0"
                y1="0"
                x2="1"
                y2="0"
                gradientUnits="userSpaceOnUse"
                gradientTransform="matrix(62.012271,0,0,62.012271,261.56935,584.72374)"
                spreadMethod="pad"
                id="linearGradient3420">
            <stop
                    style="stop-opacity:1;stop-color:#00416b"
                    offset="0"
                    id="stop3422"/>
            <stop
                    style="stop-opacity:1;stop-color:#002447"
                    offset="1"
                    id="stop3424"/>
        </linearGradient>
        <linearGradient
                x1="0"
                y1="0"
                x2="1"
                y2="0"
                gradientUnits="userSpaceOnUse"
                gradientTransform="matrix(87.768211,-70.691605,70.691605,87.768211,262.51051,656.0482)"
                spreadMethod="pad"
                id="linearGradient3440">
            <stop
                    style="stop-opacity:1;stop-color:#00416b"
                    offset="0"
                    id="stop3442"/>
            <stop
                    style="stop-opacity:1;stop-color:#00b1eb"
                    offset="0.899994"
                    id="stop3444"/>
            <stop
                    style="stop-opacity:1;stop-color:#0083ca"
                    offset="1"
                    id="stop3446"/>
        </linearGradient>
        <linearGradient
                x1="0"
                y1="0"
                x2="1"
                y2="0"
                gradientUnits="userSpaceOnUse"
                gradientTransform="matrix(-63.000489,0,0,-63.000489,282.67958,675.5111)"
                spreadMethod="pad"
                id="linearGradient3366">
            <stop
                    style="stop-opacity:1;stop-color:#d09910"
                    offset="0"
                    id="stop3368"/>
            <stop
                    style="stop-opacity:1;stop-color:#a65718"
                    offset="1"
                    id="stop3370"/>
        </linearGradient>
        <linearGradient
                x1="0"
                y1="0"
                x2="1"
                y2="0"
                gradientUnits="userSpaceOnUse"
                gradientTransform="matrix(-87.76741,70.690975,-70.690975,-87.76741,281.64442,604.26964)"
                spreadMethod="pad"
                id="linearGradient3386">
            <stop
                    style="stop-opacity:1;stop-color:#ffdd00"
                    offset="0"
                    id="stop3388"/>
            <stop
                    style="stop-opacity:1;stop-color:#d09910"
                    offset="0.899994"
                    id="stop3390"/>
            <stop
                    style="stop-opacity:1;stop-color:#ffdd00"
                    offset="1"
                    id="stop3392"/>
        </linearGradient>
    </defs>
    <sodipodi:namedview
            id="base"
            pagecolor="#ffffff"
            bordercolor="#666666"
            borderopacity="1.0"
            inkscape:pageopacity="0.0"
            inkscape:pageshadow="2"
            inkscape:zoom="0.98994949"
            inkscape:cx="180.8865"
            inkscape:cy="61.345848"
            inkscape:document-units="px"
            inkscape:current-layer="layer1"
            showgrid="false"
            fit-margin-top="0"
            fit-margin-left="0"
            fit-margin-right="0"
            fit-margin-bottom="0"
            inkscape:window-width="1920"
            inkscape:window-height="1028"
            inkscape:window-x="-8"
            inkscape:window-y="-8"
            inkscape:window-maximized="1"/>
    <metadata
            id="metadata3713">
        <rdf:RDF>
            <cc:Work
                    rdf:about="">
                <dc:format>image/svg+xml</dc:format>
                <dc:type
                        rdf:resource="http://purl.org/dc/dcmitype/StillImage"/>
                <dc:title></dc:title>
            </cc:Work>
        </rdf:RDF>
    </metadata>
    <g
            inkscape:label="Camada 1"
            inkscape:groupmode="layer"
            id="layer1"
            transform="translate(-178.95451,-562.03209)">
        <path
                d="m 221.74831,686.38094 c -0.825,1.2125 -1.30875,2.6775 -1.30875,4.255 l 0,0 c 0,4.18375 3.38875,7.56875 7.565,7.56875 l 0,0 55.435,-0.004 -35.45875,-45.3835 -26.2325,33.56375 z"
                style="fill:url(#linearGradient3366);stroke:none"
                id="path3372"
                inkscape:connector-curvature="0"/>
        <path
                d="m 219.64831,607.63469 c -4.49125,0.19375 -8.46375,2.34375 -11.08375,5.6375 l 0,0 -0.0513,0.0263 -28.43,36.375 -0.005,0.0337 c -0.69125,0.87875 -1.12375,1.97125 -1.12375,3.17875 l 0,0 c 0,1.1325 0.37875,2.17 0.99625,3.0175 l 0,0 -0.002,0.025 28.255,36.03 c 2.62625,3.63875 6.83375,6.0425 11.6225,6.20625 l 0,0 0,0.04 7.65,0 0.0725,-0.0425 c -3.9625,-0.245 -7.10875,-3.5 -7.10875,-7.52625 l 0,0 c 0,-1.5775 0.48375,-3.0425 1.30875,-4.255 l 0,0 26.2325,-33.56375 0.035,0.0388 35.42375,-45.34125 -59.655,-0.0237 -4.13625,0.14375 z"
                style="fill:url(#linearGradient3386);stroke:none"
                id="path3394"
                inkscape:connector-curvature="0"/>
        <path
                d="m 220.12956,685.96457 c -1.01125,1.28875 -1.61875,2.915 -1.61875,4.685 0,4.17 3.38125,7.555 7.55625,7.555 l 1.94625,0 c -4.1775,0 -7.55375,-3.385 -7.55375,-7.555 0,-1.77 0.605,-3.39625 1.62125,-4.685 l 25.935,-33.10875 35.42375,-45.34125 -63.31,78.45 z"
                style="fill:#ffd400;fill-opacity:1;fill-rule:nonzero;stroke:none"
                id="path3406"
                inkscape:connector-curvature="0"/>
        <path
                d="m 260.81081,562.03219 35.46375,45.38125 26.23,-33.56125 -0.001,0 c 0.82625,-1.21375 1.31,-2.675 1.31,-4.25375 l 0,0 c -2.5e-4,-4.18625 -3.3865,-7.56625 -7.56525,-7.56625 l 0,0 -55.4375,0 z"
                style="fill:url(#linearGradient3420);stroke:none"
                id="path3426"
                inkscape:connector-curvature="0"/>
        <path
                d="m 316.77581,562.03219 -0.0687,0.0412 c 3.96,0.24125 7.10625,3.4975 7.10625,7.525 l 0,0 c 0,1.57875 -0.48375,3.04 -1.31,4.25375 l 0,0 0.001,0 -26.23,33.56125 -0.035,-0.0388 -35.42875,45.34 59.6575,0.025 4.13625,-0.14 c 4.49,-0.19375 8.46375,-2.34625 11.08625,-5.64125 l 0,0 0.0487,-0.0225 28.43375,-36.37625 10e-4,-0.035 c 0.69125,-0.87625 1.12375,-1.975 1.12375,-3.17625 l 0,0 c 0,-1.13125 -0.37875,-2.16875 -1,-3.01875 l 0,0 0.004,-0.0213 -28.2525,-36.035 c -2.6235,-3.63625 -6.83225,-6.03875 -11.62225,-6.2075 l 0,0 0,-0.0337 -7.65125,0 z"
                style="fill:url(#linearGradient3440);stroke:none"
                id="path3448"
                inkscape:connector-curvature="0"/>
        <path
                d="m 324.11881,574.26357 c 1.01625,-1.2825 1.62375,-2.91125 1.62375,-4.6775 0,-4.17 -3.38125,-7.55375 -7.55375,-7.55375 l -1.94875,0 c 4.1775,0 7.55625,3.38375 7.55625,7.55375 0,1.76625 -0.6075,3.395 -1.62375,4.6775 l -25.9325,33.11 -35.42875,45.34125 63.3075,-78.45125 z"
                style="fill:#00c0f3;fill-opacity:1;fill-rule:nonzero;stroke:none"
                id="path3460"
                inkscape:connector-curvature="0"/>
        <path
                d="m 601.55531,625.91081 c -3.52,0.05 -6.485,0.485 -9.41625,1.375 -4.72875,1.44375 -8.34,4.03125 -11.0725,7.6525 -4.555,6.0075 -4.48,13.15625 -4.48,13.15625 l 0,49.8725 13.32375,0 c 0.84625,0 1.545,-0.7075 1.5475,-1.55125 l 0,-47.40625 c -0.002,-0.95 0.12875,-4.22625 1.9875,-5.885 1.47625,-1.33 3.46625,-1.97875 5.405,-2.25375 2.14875,-0.30625 4.155,-0.1675 5.15625,-0.0412 0,0 0.22,0.0137 0.33625,0.0137 0.9675,0 1.8125,-0.52125 2.28375,-1.29375 l 6.835,-11.7425 c -3.815,-1.31875 -7.5975,-1.95625 -11.90625,-1.89625"
                style="fill:#00416b;fill-opacity:1;fill-rule:nonzero;stroke:none"
                id="path3464"
                inkscape:connector-curvature="0"/>
        <path
                d="m 562.45381,625.91081 c -3.525,0.05 -6.49125,0.485 -9.41375,1.375 -4.73625,1.44375 -8.345,4.03125 -11.08625,7.6525 -4.55125,6.0075 -4.48,13.15625 -4.48,13.15625 l 0,49.8725 13.335,0 c 0.83875,0 1.54,-0.7075 1.545,-1.55125 l 0,-47.40625 c -0.005,-0.95 0.12625,-4.22625 1.9825,-5.885 1.48125,-1.33 3.46625,-1.97875 5.4075,-2.25375 2.15375,-0.30625 4.14125,-0.1675 5.15875,-0.0412 0,0 0.22,0.0137 0.33875,0.0137 0.9625,0 1.81,-0.52125 2.28875,-1.29375 l 6.82375,-11.7425 c -3.80875,-1.31875 -7.59375,-1.95625 -11.9,-1.89625"
                style="fill:#00416b;fill-opacity:1;fill-rule:nonzero;stroke:none"
                id="path3468"
                inkscape:connector-curvature="0"/>
        <path
                d="m 446.34531,679.51806 c -0.5125,-0.665 -1.30875,-1.09875 -2.21625,-1.09875 -0.50625,0 -0.985,0.145 -1.4025,0.38875 0,0 -0.0387,0.0275 -0.0462,0.0275 -4.545,2.725 -9.87,4.29875 -15.55125,4.29875 -16.72875,0 -30.34375,-13.62 -30.34375,-30.35625 0,-16.7275 13.615,-30.3425 30.34375,-30.3425 5.66875,0 10.97875,1.565 15.5275,4.2775 0.4225,0.26625 0.9275,0.41875 1.4625,0.41875 0.89625,0 1.6775,-0.41375 2.19,-1.05375 l 7.6025,-9.85625 c -7.51,-5.52 -16.7675,-8.77 -26.7825,-8.77 -24.99,0 -45.3325,20.33 -45.3325,45.32625 0,24.9975 20.3425,45.3375 45.3325,45.3375 10.02,0 19.2825,-3.26 26.7925,-8.775 l -7.57625,-9.8225 z"
                style="fill:#00416b;fill-opacity:1;fill-rule:nonzero;stroke:none"
                id="path3472"
                inkscape:connector-curvature="0"/>
        <path
                d="m 647.95418,639.19944 c 9.815,0 18.15875,6.395 21.11375,15.235 l -42.2175,0 c 2.945,-8.84 11.28625,-15.235 21.10375,-15.235 m 0,-14.3525 c -20.17875,0 -36.58875,16.41625 -36.58875,36.60125 0,19.9575 16.4225,36.3825 36.60875,36.5975 0.35875,0 1.07875,0.007 1.07875,0.007 7.96625,0 14.34375,-1.10125 22.77875,-6.57125 l 1.36375,-0.89375 c 0,0 -7.5,-9.71 -7.5775,-9.81125 -0.49875,-0.655 -1.275,-1.07625 -2.14375,-1.07625 -0.4975,0 -0.9475,0.13875 -1.3525,0.37 -1.89,0.9875 -7.76375,3.62875 -14.1675,3.63375 -9.65125,0.009 -17.88375,-6.1825 -20.9575,-14.79125 l 50.07875,0 5.78625,-0.0312 c 0.86375,0 1.555,-0.68625 1.555,-1.5425 l 0.085,-4.25125 c 0.0325,-0.555 0.0487,-1.10875 0.0487,-1.64 0,-20.185 -16.42,-36.60125 -36.59625,-36.60125"
                style="fill:#00416b;fill-opacity:1;fill-rule:nonzero;stroke:none"
                id="path3476"
                inkscape:connector-curvature="0"/>
        <path
                d="m 694.63143,698.11606 c -0.835,0 -1.52125,-0.6575 -1.55,-1.49375 l 0,-67.855 c 0.01,-0.81875 0.66875,-1.49125 1.48625,-1.5275 l 11.84375,0 c 0.85,0 1.535,0.6875 1.535,1.54375 l 0,67.8 c 0,0.845 -0.685,1.5325 -1.535,1.5325 l -11.78,0 z"
                style="fill:#00416b;fill-opacity:1;fill-rule:nonzero;stroke:none"
                id="path3480"
                inkscape:connector-curvature="0"/>
        <path
                d="m 493.37656,638.99931 c -12.17,0 -22.0775,9.9025 -22.0775,22.0825 0,12.175 9.9075,22.0825 22.0775,22.0825 12.18,0 22.0825,-9.9075 22.0825,-22.0825 0,-12.18 -9.9025,-22.0825 -22.0825,-22.0825 m 0,59.11625 c -20.415,0 -37.03125,-16.61625 -37.03125,-37.03375 0,-20.4225 16.61625,-37.04375 37.03125,-37.04375 20.425,0 37.04625,16.62125 37.04625,37.04375 0,20.4175 -16.62125,37.03375 -37.04625,37.03375"
                style="fill:#00416b;fill-opacity:1;fill-rule:nonzero;stroke:none"
                id="path3484"
                inkscape:connector-curvature="0"/>
        <path
                d="m 752.00693,639.52657 c -12.05125,0 -21.85,9.8025 -21.85,21.85375 0,12.04875 9.79875,21.84625 21.85,21.84625 12.05625,0 21.86,-9.7975 21.86,-21.84625 0,-12.05125 -9.80375,-21.85375 -21.86,-21.85375 m 0,58.49375 c -20.21,0 -36.64125,-16.44125 -36.64125,-36.64 0,-20.2175 16.43125,-36.65125 36.64125,-36.65125 20.21375,0 36.6525,16.43375 36.6525,36.65125 0,20.19875 -16.43875,36.64 -36.6525,36.64"
                style="fill:#00416b;fill-opacity:1;fill-rule:nonzero;stroke:none"
                id="path3488"
                inkscape:connector-curvature="0"/>
        <path
                d="m 830.30231,655.75831 c -2.57875,-1.1575 -5.8375,-1.90625 -9.41125,-2.79875 -5.25125,-1.3125 -10.15125,-1.59625 -11.9775,-4.43375 -1.685,-2.61125 -0.77625,-5.69125 1.50125,-7.2625 5.1825,-3.57125 12.21625,-2.14125 16.10125,-0.35125 0.66625,0.30875 3.5425,1.96625 3.5425,1.96625 0.4075,0.25375 0.89125,0.40625 1.40625,0.40625 0.9,0 1.69125,-0.44125 2.175,-1.125 0.0512,-0.0725 7.4125,-9.59875 7.4125,-9.59875 l -1.2525,-0.9875 c -0.7275,-0.53625 -1.73875,-1.23875 -2.8175,-1.855 -2.2,-1.2625 -8.885,-5.11375 -18.62625,-5.11375 -0.285,0 -0.57125,0.005 -0.86625,0.0137 -21.3525,0.50125 -24.30375,15.57125 -24.30375,20.90375 0,8.08375 4.1625,13.88125 10.42375,17.495 5,2.8925 14.4825,4.4575 19.305,5.915 2.5175,0.76125 4.38,2.5025 5.07,4.20375 0.29625,0.745 0.47375,1.53375 0.49625,2.3575 0.0925,2.7725 -1.39875,6.0025 -5.54875,7.28 -4.59,1.41 -11.84375,0.82125 -18.40875,-4.31875 -0.21,-0.16875 -0.93,-0.74625 -1.19125,-0.845 -0.3,-0.12 -0.6325,-0.17625 -0.98375,-0.17625 -0.94,0 -1.665,0.50625 -2.215,1.22375 -0.1,0.13 -7.285,9.4 -7.285,9.4 0,0 2.53375,2.09875 3.37625,2.7425 4.13625,3.10625 11.5525,7.32625 21.30875,7.32625 l 0.36375,0 c 20.525,-0.06 25.4225,-14.645 25.4225,-22.65625 0,-8.1925 -5.015,-16.1125 -13.0175,-19.71125"
                style="fill:#00416b;fill-opacity:1;fill-rule:nonzero;stroke:none"
                id="path3492"
                inkscape:connector-curvature="0"/>
    </g>
</svg>`;

